import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { styleUtils } from '../styles';
var enteringStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tbackground-color: rgba(0, 0, 0, 0);\n"])));
var enteredStyles = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tbackground-color: ", ";\n"])), styleUtils.overlay);
var exitedStyles = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tbackground-color: rgba(0, 0, 0, 0);\n"])));
function getAnimationStyle(animationState) {
  switch (animationState) {
    case 'entering':
      return enteringStyles;
    case 'entered':
      return enteredStyles;
    case 'exited':
      return exitedStyles;
    default:
      return null;
  }
}
export var bladeOverlayAnimationDurationMS = 350;
export var StyledBladeOverlay = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tposition: fixed;\n\ttop: 0px;\n\tright: 0px;\n\tbottom: 0px;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\twidth: 100%;\n\tz-index: 10;\n\ttransition: background-color ", "ms ease-in-out;\n\tanimation-duration: ", "ms;\n\t", ";\n\t@media print {\n\t\tposition: absolute;\n\t}\n"])), bladeOverlayAnimationDurationMS, bladeOverlayAnimationDurationMS, function (props) {
  return getAnimationStyle(props.animationState);
});